import React from 'react';
import { Create, SimpleForm, TextInput, SelectInput } from 'react-admin';
import DateInput from 'components/DateInput';
import { ENUMS } from 'components/Enum/enums';
import ProfessionalInput from 'components/ProfessionalInput';
import StateInput from 'components/StateInput';

const degreeOptions = Object.keys(ENUMS.Education.degree_type)
  .filter((i) => isNaN(+i))
  .map((key) => ({
    name: key,
    id: ENUMS.Education.degree_type[key],
  }));

const EducationsCreate = () => (
  <Create redirect="show">
    <SimpleForm>
      <ProfessionalInput />
      <TextInput
        label="School Name"
        source="school_name"
        data-testid="professional-education_create_school_name_field"
      />
      <SelectInput
        label="Degree Type"
        source="degree_type"
        choices={degreeOptions}
        data-testid="professional-education_create_degree_type_field"
      />
      <TextInput
        label="Field Of Study"
        source="field_of_study"
        data-testid="professional-education_create_field_of_study_field"
      />
      <TextInput
        label="City"
        source="city"
        data-testid="professional-education_create_city_field"
      />
      <StateInput data-testid="professional-education_create_state_field" />
      <DateInput label="Start Date" source="start_date" />
      <DateInput label="End Date" source="end_date" />
    </SimpleForm>
  </Create>
);

export default EducationsCreate;
